import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=749a38d7&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749a38d7')) {
      api.createRecord('749a38d7', component.options)
    } else {
      api.reload('749a38d7', component.options)
    }
    module.hot.accept("./Authorization.vue?vue&type=template&id=749a38d7&", function () {
      api.rerender('749a38d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homePage/components/Authorization.vue"
export default component.exports